import { env } from '@byted/ecom-mobile-lib';
import query from 'libs/query';

export const addThemeClass = () => {
    if (env.isInAweme) {
        document.body.classList.add('douyin');
    }

    if (env.isInToutiao || env.isInToutiaoLite) {
        document.body.classList.add('toutiao');
    }

    if (env.isInVideo) {
        document.body.classList.add('xigua');
    }

    if (env.isInHotsoon) {
        document.body.classList.add('huoshan');
    }

    if (env.isInSuper) {
        document.body.classList.add('pipixia');
    }

    if (env.isInMobile) {
        document.body.classList.add('dongchedi');
    }

    query.app && document.body.classList.add(query.app);
};
